<!-- //
Form块的标题
@auth xuyd
@date 2024-05-05
//-->
<template>
  <div class="card">
    <span class="title">{{ title }}</span>
  </div>
</template>

<script>

export default {
  name: 'CompBlockTitle',
  data() {
    return {}
  },
  props: {
    title: [String, Number],
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/variables.less';

.card {
  width: 100%;
  font-size: 12px;
  height: 22px;
  line-height: 22px;
  margin-bottom: 10px;
  text-align: left;
  border-left: 4px solid @link-color;
  background-color: @mi-color;

  .title {
    color: @label-color;
    padding-left: 4px;
  }
}
</style>
